import "reflect-metadata";

/**
 * Mongo native format, must be also indexed as 2dsphere to work
 */
export class MongoPointLocation {
  public constructor(position: { longitude: number; latitude: number }) {
    this.type = "Point";
    if (position && !isNaN(position.longitude) && !isNaN(position.latitude)) {
      this.coordinates = [position.longitude, position.latitude];
    }
  }

  public type: string = "Point";

  /**
   * [ longitude, latitude ]
   */
  public coordinates: [number, number];
}
